import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { feature } from '../../models/role.model';
import { RolesService } from '../../services/roles.service';

@Component({
	selector: 'app-role-edit',
	templateUrl: './role-edit.component.html',
	styleUrls: ['./role-edit.component.css']
})
export class RoleEditComponent implements OnInit {

	public roleForm: UntypedFormGroup;
	public submitted: boolean = false;
	@Input() roleData: any;
	public features: feature[];

	get f() {
		return this.roleForm.controls;
	}

	constructor(
		private roleService: RolesService,
		private snackbar: MatSnackBar
	) {
		
	}

	ngOnInit() {
		this.roleForm = new UntypedFormGroup({
			name: new UntypedFormControl(this.roleData?.name ?? null, Validators.required),
			features: new UntypedFormGroup({}),
		});
		console.log("Role Data", this.roleData);
		if(!this.roleData.create) {
			this.roleService.getRole(this.roleData.id).subscribe(
				response => {
					this.features = response.data.features;

					for(let i = 0; i < this.features.length; i++){
						for(let b = 0; b < this.features[i].permissions.length; b++){
							let permission = this.features[i].permissions[b];
							(this.roleForm.get('features') as UntypedFormGroup).addControl(permission.name, new UntypedFormControl(permission.is_enabled))
						}	
					}
				},
				error => {
					this.roleService.closeEditRole();
					this.snackbar.open('An error has occurred please try again!', 'Ok', { duration: 5000 });
				}
			);
		}
	}

	public submit(){
		if(!this.roleData.create) {
			let data = {
				name: this.roleForm.controls.name.value,
				permissions: Object.entries(this.roleForm.controls.features.value).filter(([key, value]) => value == true).map(([key, value]) => key)
			}

			this.roleService.updateRole(this.roleData.id, data).subscribe(
				response => {
					console.log(response);
					this.snackbar.open('Role has been succesfully updated', 'Ok', { duration: 2500 });
					this.roleService.closeEditRole();
				},
				error => {
					this.snackbar.open('An error has occurred please try again!', 'Ok', { duration: 5000 });
				}
			);
		} else {
			let data = {
				name: this.roleForm.controls.name.value,
			};

			this.roleService.createRole(this.roleData.id, data).subscribe(
				response => {
					this.snackbar.open('Role has succesfully been created', 'Ok', { duration: 2500 });
					this.roleService.closeEditRole();
				},
				error => {
					this.snackbar.open('An error has occurred please try again!', 'Ok', { duration: 5000 });
				}
			);
		}
	}

	public exitEdit() {
		this.roleService.closeEditRole();
	}

}
